"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLessonIframeVideoLoading = exports.prepareCourseWithOrderedLessons = exports.getSelectedLessonFromSlug = exports.getLessonTitleWithOrdinal = exports.composeLessonRoute = exports.composeCourseRoute = exports.LESSON_VIDEO_WRAPPER_SELECTOR = exports.COURSES_ROOT_PATH = void 0;
var _react = require("react");
var _lodash = require("lodash");
var _loader = _interopRequireDefault(require("../images/loader.gif"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var COURSES_ROOT_PATH = '/courses';
exports.COURSES_ROOT_PATH = COURSES_ROOT_PATH;
var LESSON_VIDEO_WRAPPER_SELECTOR = '.ql-video';
exports.LESSON_VIDEO_WRAPPER_SELECTOR = LESSON_VIDEO_WRAPPER_SELECTOR;
var LESSON_ORDINAL_PREFIX = 'Lesson';
var LESSONS_PATH_SLUG = 'lessons';
var LESSON_VIDEO_LOADER_ELEMENT_ID = 'ql-loading-placeholder';
var getLessonTitleWithOrdinal = function getLessonTitleWithOrdinal(title, ordinal) {
  return "".concat(LESSON_ORDINAL_PREFIX, " ").concat(ordinal, ": ").concat(title);
};
exports.getLessonTitleWithOrdinal = getLessonTitleWithOrdinal;
var composeLessonRoute = function composeLessonRoute(courseSlug, lessonSlug) {
  return "".concat(COURSES_ROOT_PATH, "/").concat(courseSlug, "/").concat(LESSONS_PATH_SLUG, "/").concat(lessonSlug);
};
exports.composeLessonRoute = composeLessonRoute;
var composeCourseRoute = function composeCourseRoute(courseSlug) {
  return "".concat(COURSES_ROOT_PATH, "/").concat(courseSlug);
};
exports.composeCourseRoute = composeCourseRoute;
var useLessonIframeVideoLoading = function useLessonIframeVideoLoading(selectedLesson) {
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    currentLessonId = _useState2[0],
    setCurrentLessonId = _useState2[1];
  var selectedLessonId = selectedLesson === null || selectedLesson === void 0 ? void 0 : selectedLesson.id;

  // We temporarily append loader element to the video wrapper container and remove it on iframe load
  var handleLoadingIndication = function handleLoadingIndication() {
    var iframeVideoWrapperElement = document.querySelector(LESSON_VIDEO_WRAPPER_SELECTOR);
    var iframeElement = document.querySelector("".concat(LESSON_VIDEO_WRAPPER_SELECTOR, " iframe"));
    var loaderElement = document.createElement('div');
    loaderElement.setAttribute('id', LESSON_VIDEO_LOADER_ELEMENT_ID);
    loaderElement.style.backgroundImage = "url(".concat(_loader.default, ")");
    loaderElement.style.backgroundRepeat = 'no-repeat';
    loaderElement.style.backgroundPosition = 'center';
    if (iframeVideoWrapperElement && loaderElement) {
      iframeVideoWrapperElement.appendChild(loaderElement);
    }
    if (iframeElement) {
      iframeElement.addEventListener('load', function (e) {
        iframeVideoWrapperElement.removeChild(loaderElement);
      }, {
        once: true
      });
    }
  };
  (0, _react.useEffect)(function () {
    if (selectedLessonId !== currentLessonId) {
      handleLoadingIndication();
      setCurrentLessonId(selectedLessonId);
    }
  }, [selectedLessonId]);
};
exports.useLessonIframeVideoLoading = useLessonIframeVideoLoading;
var prepareCourseWithOrderedLessons = function prepareCourseWithOrderedLessons(course) {
  var lessons = course.lessons;
  return _objectSpread(_objectSpread({}, course), {}, {
    lessons: (0, _lodash.orderBy)(lessons, [function (lesson) {
      var courseLessons = lesson.courseLessons;
      var currentCourseLesson = courseLessons[0];
      var order = currentCourseLesson.order;
      return order;
    }], ['asc']).map(function (lesson, index) {
      return _objectSpread(_objectSpread({}, lesson), {}, {
        ordinal: index + 1
      });
    })
  });
};
exports.prepareCourseWithOrderedLessons = prepareCourseWithOrderedLessons;
var getSelectedLessonFromSlug = function getSelectedLessonFromSlug(course, lessonSlug) {
  var lessons = course.lessons;
  var selectedLesson = lessons.find(function (lesson) {
    return lesson.slug === lessonSlug;
  });
  return selectedLesson;
};
exports.getSelectedLessonFromSlug = getSelectedLessonFromSlug;